let commoditytypes = [
  "Personal Effect",
  "General Cargo",
  "Break Bulk",
  "Dangerous Goods",
];
export default commoditytypes;
